module.exports = __webpack_public_path__ + "img/7days.0dd8c4cc.png";